<template>
  <customModal :containermd=true :bodyxl = true :footerShow = true @closeModal="closeTaskModal">
    <template #title>
       <h4 class="my-0"> Manage Task</h4>
    </template>
    <template #body>
      <form >   
        <div class="ibox-content mb-2">
            <div class="form-row">
                <div class="col-lg-6 mb-1">
                    <label class="mb-0">{{ $t('navigations.taskid') }} </label>
                    <input 
                        type="text"
                        maxlength="1000"
                        class="form-control"
                        v-model="values.taskId"
                        />
                </div>
                <div class="col-lg-6 mb-1">
                    <label class="mb-0">{{ $t('navigations.tasktitle') }} </label>
                    <input type="text" v-model="values.taskTitle"  maxlength="1000" class="form-control"/>
                </div>
                <div class="col-lg-12 mb-1">
                    <label class="mb-0">{{ $t('navigations.description') }}</label>
                    <textarea class="custom-textarea" v-model="values.description" rows="3" ></textarea>
                </div>

                <div class="col-12 col-md-6 mb-2">
                    <label for="roleList" class="form-label">{{$t("navigations.role")}}</label>
                    <Multiselect
                        id="roleList"
                        class="multiselect-theme"
                        v-model="values.ownerRoles"
                        @update:modelValue="onSelectClosed"
                        @clear="onClear"
                        mode="multiple"
                        placeholder="Select roles"
                        label-prop="roleName"
                        value-prop="roleID"
                        :options="roleList"
                        :object="true"
                        :close-on-select="false"
                        :searchable="true"
                        :hide-selected="false"
                    >
                        <template v-slot:option="{ option }">
                            {{ option.roleName }}
                        </template>
                    </Multiselect>
                </div>
                <div class="col-12 col-md-6 mb-2">
                    <label for="recipients" class="form-label">{{$t("navigations.responsibleOwner")}}</label>
                    <Multiselect
                        @clear="onRecipientClear()"
                        id="recipients"
                        valueProp="email"
                        mode="multiple"
                        placeholder="Select"
                        v-model="values.owner"
                        :options="userList"
                        :hideSelected="false"
                        :closeOnSelect="false"
                        class="multiselect-theme"
                    
                    >
                    <template v-slot:option="{ option }">
                        <span v-if="option">{{ option.email }}</span>
                    </template>
                    </Multiselect>
                </div>
                <div class="col-lg-6 mb-1">
                    <label class="mb-0">{{ $t('navigations.start date') }} </label>
                    <input type="date" v-model="values.startDate"  maxlength="1000" class="form-control" />
                </div>
                <div class="col-lg-6 mb-1">
                    <label class="mb-0">{{ $t('navigations.end date') }} </label>
                    <input type="date" v-model="values.endDate" maxlength="1000" class="form-control" />
                </div>
                <div class="col-lg-6 mb-1">
                    <label class="mb-0">{{ $t('navigations.plannedEndDate') }} </label>
                    <input type="date" v-model="values.plannedEndDate"  maxlength="1000" class="form-control" />
                </div>
                <div class="col-lg-6 mb-1">
                    <label class="mb-0">{{ $t('navigations.priority') }} </label>
                    <select class="form-control" v-model="values.priority">
                        <option value="Low">Low </option>
                        <option value="Moderate">Moderate</option>
                        <option value="High">High</option>
                    </select>
                </div>
                <div class="col-lg-6 mb-1">
                    <label class="mb-0">{{ $t('navigations.status') }} </label>
                    <select class="form-control" v-model="values.status">
                        <option value="In Progress">In Progress</option>
                        <option value="Completed">Completed</option>
                        <option value="Closed">Closed</option>
                    </select>
                </div>
                <div class="col-lg-12 mb-1">
                    <label class="mb-0">{{ $t('navigations.comments') }}</label>
                    <textarea class="custom-textarea" v-model="values.comments" rows="3" ></textarea>
                </div>
            </div>
        </div>
    </form>
    </template>
    <template #footer>
          <div class="col-lg-12 mt-1 d-flex justify-content-lg-end">
              <button
                class="cancel_btn py-1 px-4 mx-3"
                type="button"
                @click.prevent="clear()"
              >
                {{ $t("navigations.clear") }}
              </button>
              <button
                class="save_btn py-1 px-4"
                type="button"
                @click.prevent="saveClicked()"
              >
                {{ $t("navigations.save") }}
              </button>
            </div>
       
    </template>
  </customModal>
</template>

<script src="./ManageRIskTaskModal.js"></script>

<style scoped>

.custom-textarea:focus-visible{
    outline: 1px solid #9ca2a8;
}
.custom-textarea{
    border: 1px solid #ced4da;
}
.rbqm-table {
    width: 100%;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    overflow: hidden;
}

.rbqm-thead,
.rbqm-row {
    display: grid;
    grid-template-columns: 50px 1fr 100px 100px 100px 100px 100px 20px ;
    align-items: center;
}
.rbqm-row{
    border-top: 1px solid #e5e7eb
}

.rbqm-thead {
    background: #fbfcfe;
    color: var(--muted);
    font-weight: 600;
    letter-spacing: .2px;
    border-bottom: 1px solid #e5e7eb;
    padding: 6px 7px;
}

.cell {
    padding: 4px 4px
}

/* left index pill */
.index {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 6px;
    background: #2f6fb5;
    color: #fff;
    font-weight: 600;
}
.multiselect-theme {
  --ms-option-bg-selected-pointed: rgb(210, 210, 210);
  --ms-option-bg-selected: rgb(210, 210, 210);
  --ms-option-color-selected: #000;
  --ms-option-color-selected-pointed: #000;
}

</style>